import React, { createContext, useContext, useEffect } from 'react';

interface ThemeContextValue {
  theme: 'light';
}

const ThemeContext = createContext<ThemeContextValue>({ theme: 'light' });

/**
 * Applies the eti-ui palmetto theme class to <html> (the eti-ui stylesheet keys
 * every CSS variable off .theme-palmetto) and pins light mode, matching the
 * sibling Palmetto apps - there is no dark mode.
 */
export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('theme-palmetto');
  }, []);

  return <ThemeContext.Provider value={{ theme: 'light' }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
